var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"w-200",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.timeLeft))])}
var staticRenderFns = []

export { render, staticRenderFns }